function allowedTemplateMessageAttachments(attachmentType) {
  let fileList;
  switch (attachmentType) {
    case 'document':
      fileList = ['pdf']; // , 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'
      break;
    case 'image':
      fileList = ['jpg', 'jpeg', 'png'];
      break;
    // case 'audio':
    //   fileList = ['aac', 'm4a', 'amr', 'mp3', 'ogg'];
    //   break;
    case 'video':
      fileList = ['mp4']; // , '3gpp'
      break;
    default:
      break;
  }
  return fileList;
}

function getMediaTypeFromExtension(extension) {
  let type;
  switch (extension) {
    case 'pdf':
    case 'doc':
    case 'docx':
    case 'ppt':
    case 'pptx':
    case 'xls':
    case 'xlsx':
    case 'csv':
      type = 'document';
      break;
    case 'jpg':
    case 'jpeg':
    case 'png':
      type = 'image';
      break;
    case 'aac':
    case 'm4a':
    case 'amr':
    case 'mp3':
    case 'ogg':
      type = 'audio';
      break;
    case 'mp4':
    case '3gpp':
      type = 'video';
      break;
    default:
      break;
  }

  return type;
}

function getMediaType(mimeType) {
  const types = mimeType.split(';')[0].split('/');

  switch (types[0]) {
    case 'image':
      return 'image';
    case 'video':
      return 'video';
    case 'audio':
      return 'audio';
    case 'text':
      return 'text';
    case 'application':
      switch (types[1]) {
        case 'pdf':
          return 'pdf';
        case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        case 'vnd.ms-excel':
        case 'vnd.openxmlformats-officedocument.spreadsheetml.template':
        case 'vnd.ms-excel.sheet.macroEnabled.12':
        case 'vnd.ms-excel.template.macroEnabled.12':
        case 'vnd.ms-excel.addin.macroEnabled.12':
        case 'vnd.ms-excel.sheet.binary.macroEnabled.12':
          return 'excel';
        case 'msword':
        case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'vnd.openxmlformats-officedocument.wordprocessingml.template':
        case 'vnd.ms-word.document.macroEnabled.12':
        case 'vnd.ms-word.template.macroEnabled.12':
          return 'word';
        case 'vnd.ms-powerpoint':
        case 'vnd.openxmlformats-officedocument.presentationml.presentation':
        case 'vnd.openxmlformats-officedocument.presentationml.template':
        case 'vnd.openxmlformats-officedocument.presentationml.slideshow':
        case 'vnd.ms-powerpoint.addin.macroEnabled.12':
        case 'vnd.ms-powerpoint.presentation.macroEnabled.12':
        case 'vnd.ms-powerpoint.template.macroEnabled.12':
        case 'vnd.ms-powerpoint.slideshow.macroEnabled.12':
          return 'powerpoint';
        default:
          return 'file';
      }
    case 'xls':
    case 'xlsx':
      return 'excel';
    case 'ppt':
    case 'pptx':
      return 'powerpoint';
    case 'pdf':
      return 'pdf';
    default:
      return 'file';
  }
}

/**
 * Temporary function which serves as a fallback for the type shown in the conversation last message section.
 * getMediaType will be used once last_message_media_type is added on the conversations payload.
 * @param {*} mimeType
 */
function getMediaTypeForLastMessage(mimeType) {
  const types = mimeType.split(';')[0].split('/');

  switch (types[0]) {
    case 'image':
      return 'image';
    case 'video':
      return 'video';
    case 'audio':
      return 'audio';
    case 'voice': // fallback if we get voice instead of audio
      return 'audio';
    case 'text':
      return 'text';
    case 'application':
      return 'document';
    default:
      if (types[0]) {
        return 'document';
      }
      return null;
  }
}

function getMediaIcon(mediaType) {
  switch (mediaType) {
    case 'video':
      return 'regular/file-video';
    case 'audio':
      return 'regular/file-audio';
    case 'image':
      return 'regular/file-image';
    case 'text':
      return 'regular/file-alt';
    case 'pdf':
      return 'regular/file-pdf';
    case 'excel':
      return 'regular/file-excel';
    case 'powerpoint':
      return 'regular/file-powerpoint';
    case 'word':
      return 'regular/file-word';
    default:
      return 'regular/file-alt';
  }
}

function getMediaName(mediaUrl) {
  return mediaUrl.split('/').pop();
}

/**
 * Returns the file extension without 'dot'.
 * @param {*} fileName File name for which the extension is needed.
 */
function getFileExtension(fileName) {
  try {
    return fileName.split('.').pop().toLowerCase();
  } catch (error) {
    return '';
  }
}

export {
  allowedTemplateMessageAttachments,
  getMediaTypeFromExtension,
  getMediaType,
  getMediaTypeForLastMessage,
  getMediaIcon,
  getMediaName,
  getFileExtension,
};
